import { useState } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../css/main.css';
import TaskInfo from './TaskInfo';
import TimeLog from './TimeLog';

const SlideTask = ({ show, onClose, data }) => {
  const [activeTab, setActiveTab] = useState('task'); // 'task' or 'time'

  if (!show || !data) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 backdrop-blur-sm z-40" onClick={onClose} />

      {/* Sidebar */}
      <div className="fixed top-0 right-0 w-full sm:w-105 h-full bg-white z-50 shadow-lg overflow-y-auto transition-transform duration-300 scrollbar-hide">
        <div className="p-2 pt-6">
          {/* Close Button */}
          <div className="flex justify-between items-center">
            <div className="flex gap-[1px]">
              <button
                onClick={() => setActiveTab('task')}
                className={`px-6 py-2 pb-1  text-sm font-medium ${
                  activeTab === 'task' ? 'bg-gray-200 text-gray-800 rounded-t-lg ' : 'bg-gray-100 text-gray-500 rounded-t-lg '
                }`}
              >
                INFO
              </button>
              <button
                onClick={() => setActiveTab('time')}
                className={`px-3 py-2 pb-1  text-sm font-medium ${
                  activeTab === 'time' ? 'bg-gray-200 text-gray-800 rounded-t-lg' : 'bg-gray-100 text-gray-500 rounded-t-lg'
                }`}
              >
                Time Log
              </button>
            </div>
            <button onClick={onClose} className="text-gray-600 hover:text-black text-xl">×</button>
          </div>

          {/* Content Switch */}
          {activeTab === 'task' && <TaskInfo data={data} />}
          {activeTab === 'time' && <TimeLog data={data} />}
        </div>
      </div>
    </>
  );
};

export default SlideTask;
